const crypto = require('crypto')
const url = require('url')

function removeWebSafe(safeEncodedString) {
  return safeEncodedString.replace(/-/g, '+').replace(/_/g, '/')
}

function makeWebSafe(encodedString) {
  return encodedString.replace(/\+/g, '-').replace(/\//g, '_')
}

function decodeBase64Hash(code) {
  // "new Buffer(...)" is deprecated. Use Buffer.from if it exists.
  return Buffer.from ? Buffer.from(code, 'base64') : new Buffer(code, 'base64')
}

function encodeBase64Hash(key, data) {
  return crypto.createHmac('sha1', key).update(data).digest('base64')
}

export function sign(path, secret) {
  const uri = url.parse(path)
  const safeSecret = decodeBase64Hash(removeWebSafe(secret))
  const hashedSignature = makeWebSafe(encodeBase64Hash(safeSecret, uri.path))
  return url.format(uri) + '&signature=' + hashedSignature
}
